import { SVGProps } from 'react'

import { LibraryIcons } from './Library'
import { IconsName } from './types'

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconsName
}

export function Icon({ name, ...props }: Readonly<IconProps>): JSX.Element {
  const IconComponent = LibraryIcons[name]

  if (!IconComponent) return <></>

  return <IconComponent aria-hidden='true' data-testid={`${name}-icon-test`} {...props} />
}
